import { Question } from '../types/quiz'
import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { breakpoints } from '../assets/styles/mediaBreakpoints'
import { WhiteBox } from '../assets/styled_components/boxStyle'
import BackAndNext from '../components/common/composite/backAndNext'
import { useNavigate } from 'react-router-dom'
import { getMostRepeatElement } from '../services/service'

const QuizPhase2 = ({ questions }: { questions: Question[] }) => {
  const navigate = useNavigate()
  const [sdgs, setSdgs] = useState<string[]>([])
  const [currentSdg, setCurrentSdg] = useState('')
  const [currentChoice, setCurrentChoice] = useState('')
  const [index, setIndex] = useState(0)

  useEffect(() => {
    if (questions.length === 0) navigate('/quiz-p')
  }, [])

  const handleNext = () => {
    setSdgs((prev) => [...prev, currentSdg])
    if (index < questions.length - 1) {
      setIndex((prev) => prev + 1)
    } else {
      const final_sdg = getMostRepeatElement(sdgs)?.split('sdg')[1]
      navigate(`/quiz-result/${final_sdg}`)
    }
    setCurrentSdg('')
    setCurrentChoice('')
  }

  const currentQuestion = questions[index]

  return (
    <QuizSection>
      {currentQuestion ? (
        <>
          <QuizTitleContainer>
            <h4>{currentQuestion.question}</h4>
            <p style={{ fontSize: '20px' }}>Choose your answer</p>
          </QuizTitleContainer>
          <QuizChoiceContainer>
            {currentQuestion.choices.map((choice, i) => (
              <QuizChoice
                key={i}
                $arr={currentChoice === '' ? [] : [currentChoice]}
                $item={choice.answer}
                onClick={() => {
                  setCurrentChoice(choice.answer)
                  setCurrentSdg(choice.sdg)
                }}
              >
                <p>{choice.answer}</p>
              </QuizChoice>
            ))}
          </QuizChoiceContainer>
        </>
      ) : null}
      <BackAndNext onClick={handleNext} isDisabled={currentChoice === ''} />
    </QuizSection>
  )
}

const QuizSection = styled.div`
  width: 100%;
  background: radial-gradient(
    ellipse at 50% 200px,
    ${(props) => props.theme.colors['primary-100']} 0%,
    ${(props) => props.theme.colors['secondary-200']} 34%,
    ${(props) => props.theme.colors['primary-100']} 95%
  );
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
  padding: 120px 64px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 48px;
  @media (max-width: ${breakpoints.mobile}px) {
    padding: 64px 24px;
    background: radial-gradient(
      circle at 50% 200px,
      ${(props) => props.theme.colors['primary-100']} 0%,
      ${(props) => props.theme.colors['secondary-200']} 34%,
      ${(props) => props.theme.colors['primary-100']} 95%
    );
  }
`
const QuizTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
  align-items: center;
  text-align: center;
`
const QuizChoiceContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: center;

  & > * {
    flex: 1 1;
    max-width: 500px;
  }

  @media (max-width: ${breakpoints.tablet}px) {
    max-width: 100%;
  }
`
const QuizChoice = styled(WhiteBox)`
  min-width: 100%;
`

export default QuizPhase2
